import React from "react";
import AccountMappingContent from "../../components/AccountMappingContent";

function Step2() {
    return (
      <AccountMappingContent
        nextStepLink={"/jobber-xero-step3"}
      ></AccountMappingContent>
    );
}

export default Step2;
